<template>
  <document-container
      v-if="template" :footer="template.footer()" :header="template.header()" :logo="logo" :timeout="3000" documentType="factsheet"
  >

    <div slot="raw-body" class="factsheet-table page-block">
      <div class="columns">
        <div class="column">
          <h2>Strategie</h2>
          <p>
            {{ product.specific ? product.specific.strategy : 'Leider steht zu diesem Produkt keine Strategie zur Verfügung.' }}
          </p>
        </div>
        <div v-if="product.issuer" class="column is-3">
          <h2>Anschrift</h2>
          {{ product.issuer.issuerName }}<br> {{ product.issuer.issuerStreet }}<br>
          {{ product.issuer.issuerPostalCode }} {{ product.issuer.issuerCity }} <br> {{ product.issuer.issuerUrl }}
        </div>
      </div>
      <hr>
    </div>
    <div slot="raw-body" class="factsheet-table page-block">
      <div class="columns">
        <div class="column is-5" style="padding-right: 20px">
          <h2>Produkt in Zahlen</h2>
          <div>
            <div
                v-for="field in filteredBaseTable" class="columns field"
            >
              <div class="column"><strong>{{ field.label }}</strong></div>
              <div
                  :is="'tablefield-' + field.fieldType" :config="getFieldConfig(field)" :data="getFieldData(field.key)" :product="product" class="column basetable-field"
              ></div>
            </div>
          </div>
        </div>
        <div class="column is-7">
          <div class="columns">
            <div class="column">
              <chart-container
                  slot="raw-body" :chartData="developmentChart" :chartType="'ChartHistory'" :heading="'Kursentwicklung'" :settings="{
                  style: {
                    width: 380,
                    height: 150
                  }
                }"
              ></chart-container>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <chart-container
                  v-if="mifidPerformance" :chart-data="mifidPerformance" :settings="{style: {height: 110,width: 380}}" chart-type="ChartVerticalBar" heading="5 Jahresentwicklung (%)"
              ></chart-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div slot="raw-body" class=" page-block" style="padding-bottom: 0">
      <hr>
      <div class="columns">
        <div class="column is-4">
          <h3>Wertentwicklung des Fonds</h3>

        </div>
        <div class="column">

          <table class="table is-narrow table-report-development" style>
            <thead>
            <tr>
              <th></th>
              <th style="text-align:right">Year-to-Date</th>
              <th style="text-align:right">1 Monat</th>
              <th style="text-align:right">6 Monate</th>
              <th style="text-align:right">1 Jahr</th>
              <th style="text-align:right">3 Jahre</th>
              <th style="text-align:right">5 Jahre</th>
              <th style="text-align:right">10 Jahre</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in performanceTable" class="field underlying">
              <th>
                <strong>{{ row.label }}</strong>
              </th>
              <td v-for="time in ['YTD','P1M','P6M','P1Y','P3Y','P5Y','P10Y']" style="text-align:right">
                <tablefield-percent :data="row.data[time]"></tablefield-percent>
                <!--            <span v-if="row.fieldType === 'number'" v-html="row[time].date ? row[time].date.toFixed(2) : '-&#45;&#45;'"></span>-->
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <hr>
    </div>

    <div slot="raw-body" class=" page-block" style="padding-bottom: 0">
      <div class="columns">
        <div class="column is-4">
          <h3>Kennzahlen in Fondswährung</h3>

        </div>
        <div class="column">

          <table>
            <tr>
              <th>Max Draw Down 5 Jahre</th>
              <td>
                <tablefield-percent
                    :data="getFieldData('fundCurrencyFigures.maximumDrawDownFiveYears.value')"
                ></tablefield-percent>
              </td>
              <th>Max Time to Recovery 5 Jahre</th>
              <td>
                <tablefield-text
                    :data="getFieldData('fundCurrencyFigures.maximumTimeToRecoverFiveYears.value') + ' Tage'"
                ></tablefield-text>
              </td>
            </tr>
            <tr>
              <th>Max Draw Down Auflage</th>
              <td>
                <tablefield-percent
                    :data="getFieldData('fundCurrencyFigures.maximumDrawDownSinceInception.value')"
                ></tablefield-percent>
              </td>
              <th>Value-at-Risk 1 Jahr</th>
              <td>
                <tablefield-percent
                    :data="getFieldData('fundCurrencyFigures.valueAtRiskOneYear.value')"
                ></tablefield-percent>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <hr>
    </div>

    <div slot="raw-body" class=" page-block" style="padding-bottom: 0">
      <div class="columns">
        <div class="column is-4"><h3>Kennzahlen in Euro</h3></div>
        <div class="column">

          <!--      <h2>Risiko-/Relative Kennzahlen</h2>-->
          <table class="table is-narrow table-report-development">
            <thead>
            <tr>
              <th></th>
              <th style="text-align:right">1 Jahr</th>
              <th style="text-align:right">3 Jahre</th>
              <th style="text-align:right">5 Jahre</th>
              <th style="text-align:right">10 Jahre</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in riskTable" class="field underlying">
              <td>
                <strong>{{ row.label }}</strong>
              </td>
              <td v-for="time in ['P1Y','P3Y','P5Y','P10Y']" style="text-align:right">
                <tablefield-percent
                    :data="row.data && row.data[time] ? row.data[time].value : null"
                ></tablefield-percent>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <hr>

    </div>

    <template v-if="barchart.length > 0">
      <div v-for="(pair, index) in [[0,1], [2,3], [4]]" slot="raw-body" class=" page-block">
        <template v-if="index === 0">
          <h2>Portfolioaufteilung</h2>
          <hr style="margin-bottom: 15px">
        </template>

        <div class="columns">
          <div
              v-for="barchartIndex in pair" v-if="barchart[barchartIndex]" class="column is-half" style="float:left; margin-bottom: 20px"
          >
            <chart-container
                :chart-data="barchart[barchartIndex].data" :heading="barchart[barchartIndex].label" :settings="barChartSettings" chart-type="ChartHorizontalBar"
            ></chart-container>
            <span style="color: #666; margin-top: 10px; float:right">{{ barchart[barchartIndex].info }}</span>
          </div>
        </div>

      </div>

    </template>

    <div v-if="template.config.disclaimer.body.length > 0" slot="raw-body" class=" page-block">

      <textblock
          :data="template.config.disclaimer"
      ></textblock>
    </div>

    <div
        v-if="template.config.longDisclaimer && template.config.longDisclaimer.body.length > 0"
        slot="raw-body"
        class="page-block"
    >
      <pagebreak></pagebreak>
    </div>

    <div
        v-if="template.config.longDisclaimer && template.config.longDisclaimer.body.length > 0" slot="raw-body" class=" page-block"
    >
      <textblock
          :data="template.config.longDisclaimer"
      ></textblock>
    </div>
  </document-container>
</template>

<script>
import ProductService from '../../service/ProductService'
import ConfigService from '../../service/ConfigService'
import TemplateService from '../../service/TemplateManager'
import DocumentContainer from '../document/DocumentContainer'
import PaybackTextContainer from './payback/PaybackTextContainer'
import BlockMixin from '../block/BlockMixin'
import { TableCollection } from '../../model/table/TableCollection'
import ReportBaseFigures from './ReportBaseFigures.vue'
import TablefieldPercent from "../table-field/FieldPercent"
import ChartContainer from "../chart/ChartContainer"
import FieldMixin from "../table-field/FieldMixin"
import TablefieldDecimal from "../table-field/FieldDecimal"
import TokenService from "../../service/TokenService"


export default {
  components: {
    TablefieldDecimal,
    ChartContainer,
    TablefieldPercent,
    ReportBaseFigures,
    DocumentContainer,
    PaybackTextContainer,
  },

  name: 'fond',

  data() {
    return {
      barChartSettings: {
        style: {
          width: 332,
          height: 170,
        },
      },
      product: {},
      template: null,
      chartData: null,
      labels: {},
      tables: {
        type: TableCollection,
      },
      fields: [
        'enriched.underlying.indices',
        'enriched.assetClass',
        'enriched.distributionStrategy',
        'enriched.chart.allocation.country.data',
        'enriched.tmc.product.positive.riskIndicator',
        'enriched.graph.performance.series',
        'enriched.tmc.table.rows',
        'enriched.statistics.performance.mifidPerformances',
      ],
      baseTable: [
        {
          label: 'ISIN',
          key: 'ids.isin',
          fieldType: 'text',
        },
        {
          label: 'Auflagedatum',
          key: 'common.issueDate',
          fieldType: 'date',
        },
        {
          label: 'Ausgabeaufschlag KVG',
          key: 'derived.issueSurcharge',
          fieldType: 'percent',
          etf: 'hide',
        },
        {
          label: 'Index',
          key: 'enriched.underlying.indices',
          fieldType: 'percent',
          etf: 'show',
        },
        {
          label: 'Anlageklasse',
          key: 'enriched.assetClass',
          fieldType: 'text',
        },
        {
          label: 'Anlagefokus',
          key: 'specific.investmentFocus',
          fieldType: 'text',
        },
        {
          label: 'Anlageregion',
          key: 'specific.investmentRegion',
          fieldType: 'text',
        },
        {
          label: 'Ertragsverwendung',
          key: 'enriched.distributionStrategy',
          fieldType: 'text',
        },
        {
          label: 'Abbildungsart',
          key: 'specific.etfStructure',
          fieldType: 'text',
          etf: 'show',
        },
        {
          label: 'Risiko-Indikator (SRI)',
          key: 'enriched.tmc.product.positive.riskIndicator',
          fieldType: 'text',
        },
        {
          label: 'SRRI',
          key: 'specific.risk.srri',
          fieldType: 'text',
        },
        {
          label: 'Rücknahmeabschlag',
          key: 'specific.costs.redemptionFee.value',
          fieldType: 'currency',
        },
        {
          label: 'Laufende Kosten',
          key: 'fundCosts.exPost.runningCosts',
          fieldType: 'percent',
        },
        {
          label: 'Transaktionskosten',
          key: 'fundCosts.exPost.transactionalCosts',
          fieldType: 'percent',
        },
        {
          label: 'Total Expense Ration',
          key: 'common.ter',
          fieldType: 'percent',
        },

      ],
    }
  },

  mixins: [BlockMixin, FieldMixin],

  head: {
    link: function () {
      return [
        {
          rel: 'stylesheet',
          href: '/config/' + this.environment + '/style/factsheet.css',
        },
      ]
    },
  },

  props: {
    environment: {
      type: String,
    },
    dq: {
      type: String,
    },
    appInstance: {
      type: String,
      required: false,
    },
  },

  methods: {
    cssvar(name) {
      return getComputedStyle(document.documentElement).getPropertyValue(name)
    },
    getFieldData(path) {
      return this._.get(this.product, path, '—')
    },
    getFieldConfig(field) {
      return this._.get(field, 'config', {})
    },
    getSortedMifidPerformances() {
      return this._.get(this.product, 'enriched.statistics.performance.mifidPerformances', [])
          .sort((e1, e2) => {
            return this.moment(e2.startDate).unix() - this.moment(e1.startDate).unix()
          })
    },
  },

  computed: {
    filteredBaseTable() {
      return this.baseTable.filter(el => {
        return this._.get(this.product, 'specific.characteristics.etf') ?
            this._.get(el, 'etf', 'show') === 'show' :
            this._.get(el, 'etf', 'hide') === 'hide'
      })
    },
    developmentChart() {
      return {
        labels: this._.get(this.product, 'enriched.graph.performance.series[0].values', []).map(el => {
          return this.moment(el.x).format('MMMM YYYY')
        }),
        datasets: [
          {
            label: this._.get(this.product, 'name', '').length > 40 ? this.product.name.slice(0, 40) + '...' : this._.get(this.product, 'name'),
            borderColor: this.cssvar('--chart-bg-color'),
            fill: false,
            lineTension: 0,
            borderJoinStyle: 'round',
            backgroundColor: 'rgba(0,0,0,0)',
            pointRadius: 0,
            data: this._.get(this.product, 'enriched.graph.performance.series[0].values', []).map(el => el.y),
            // data: this.product.prices[this.product.product.underlying].prices.map(price => {
            //   let searchResult = this.product.prices[this.product.product.dq].prices.find(needle => {
            //     return price.localDate === needle.localDate
            //   })
            //
            //   return this._.get(searchResult, 'anyPrice', null);
            // })
          },
        ],
      }
    },
    mifidPerformance() {
      let barTypeSettings = [
        {
          backgroundColor: this.cssvar('--chart-bg-color'),
          path: 'euroValue',
        },
      ]
      if (this.product.common.currency !== 'EUR') {
        barTypeSettings.push({
          backgroundColor: this.cssvar('--chart-bg-color-2'),
          path: 'fundCurrencyValue',
        })
      }


      return {
        labels: this.getSortedMifidPerformances().map(el => {
          return this.moment(el.startDate).format('MM/YY') + ' - ' + this.moment(el.endDate).format('MM/YY')
        }),
        datasets: barTypeSettings.map(barType => {
          return {
            label: barType.label,
            barThickness: 130,
            backgroundColor: barType.backgroundColor,
            data: this.getSortedMifidPerformances().map(el => (el[barType.path] * 100)),

            // data: this.debugData
          }
        }),

      }
    },
    logo() {
      return '/config/' + this.environment + '/images/logo.png'
    },
    time() {
      return this.moment().format('[Stand:] DD. MMMM YYYY')
    },
    barchart() {
      if (this.product) {

        let bg
        //
        // switch (this.environment) {
        //   case 'hauck':
        //     bg = '#1A4AA0'
        //     break
        //   case ''
        // }

        return Object.values(this._.get(this, 'product.enriched.chart.allocation', {})).map(el => {
          return {
            label: this._.get(el.data[0], 'label'),
            info: el.info,
            data: {
              labels: this._.get(el.data[0], 'values', []).map(d => {
                return d.x.length > 25 ? d.x.slice(0, 20) + '...' : d.x
              }),
              datasets: [{
                data: this._.get(el.data[0], 'values', []).map(d => d.y * 100),
                backgroundColor: this.cssvar('--chart-bg-color'),
              }],
            },
          }
        })
      }
    },
    performanceTable() {
      let table = [
        {
          name: 'fund',
          translation: 'EUR',
        },
        {
          name: 'fundFundCurrency',
          translation: 'Fondswährung',
        },
      ]

      return table.map(el => {
        return {
          label: this._.get(el, 'translation'),
          data: {
            ...this._.get(this.product, `statistics.performance.${el.name}.values.values`, '—'),
            YTD: this._.get(this.product, `statistics.performance.${el.name}.ytd.value`),
          },
        }
      })
    },
    riskTable() {
      const table = {
        volatility: 'Volatilität',
        trackingError: 'Tracking Error',
        alpha: 'Alpha',
        beta: 'Beta',
        sharpeRatio: 'Sharpe Ratio',
        treynor: 'Treynor Ratio',
        informationRatio: 'Information Ratio',
      }

      return Object.keys(table).map(el => {
        return {
          label: table[el],
          data: this._.get(this.product, `statistics.ratios.${el}.details`),
        }
      })
    },
  },

  async created() {

    let token
    if (!this.$route.query.token) {
      token = await TokenService.checkToken()
    } else {
      token = this.$route.query.token
    }

    let options = []

    if (this.$route.query.date) {
      options.push(
          {
            name: 'date',
            value: this.$route.query.date,
          },
      )
    }

    if (this.$route.query.quote) {
      options.push(
          {
            name: 'quote',
            value: this.$route.query.quote,
          },
      )
    }

    ProductService.getProductForFactsheet(
        this.environment,
        this.appInstance,
        this.dq,
        token,
        options,
        this.fields,
    ).then(res => {
      this.product = res.data.data

      this.product.enriched.tmc.table.rows = this._.get(this.product, 'enriched.tmc.table.rows', []).filter(el => !['Vertriebsstrategie', 'Risiko-Indikator (SRI)', 'Risiko-/Renditeprofil'].includes(el.criterion))
      // this.chartData = this.mapChartData()

      ConfigService.getDocumentConfig(
          this.environment,
          'factsheet',
          'default',
          'default',
      ).then(result => {
        let config = result.data
        config.title.title = this.product.name
        this.template = new TemplateService(config)
      })

    })

  },
}
</script>

<style>
.factsheet .page-title h1 {
  max-width: 510px !important;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.basetable-field {
  max-width: 200px;
  text-align: right;
}

</style>



// WEBPACK FOOTER //
// Factsheet.vue?4be7ed56